import $ from 'jquery';

$(() => {
  if (window.devicePixelRatio && window.devicePixelRatio > 1) {
    $('[data-hires-bg]').each(function() {
      const src = $(this).data('hires-bg');
      $(this).css('background-image', `url(${src})`);
    });
  }
});
